var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Mobile Raises:"}},[_c('b-button',{attrs:{"variant":"link","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n\t\t"+_vm._s((_vm.raisesNumber + " raise types associated"))+"\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }